import { batchActions } from 'redux-batched-actions';
import { get } from 'lodash';

import { fetchWithSpinner, fetchWrapper as fetch } from '../utils/fetch';
import { processAdminPanelItems, processAdminPanelUsers, processGetUserData, processMessagesSupportPanel, processReportPanel, processSupportPanel, processTicketInfo } from '../utils/responseProcessing';
import {
    SEARCH_RESULT_ITEMS_PER_PAGE,
    ERROR_USER_NOT_FOUND,
    USERS_RESULT_ITEMS_PER_PAGE,
    SUPPORT_ITEMS_LIMIT,
} from '../utils/constants';
import urls from '../apiUrls';

import { closeDialog, openDialog } from "./Dialog";
import { openDialogError } from './DialogError';
import DialogSupportComplete from "../containers/DialogSupportCWrapper/DialogSupportCWrapper";
import React from 'react';


export const CHANGE_ADMIN_RESULT_ITEMS_ORDERING = 'CHANGE_ADMIN_RESULT_ITEMS_ORDERING'
export const START_FETCHING_ADMIN_PANEL = 'START_FETCHING_ADMIN_PANEL';
export const SET_ERROR_FETCHING_ADMIN_PANEL = 'SET_ERROR_FETCHING_ADMIN_PANEL';
export const SET_ERROR_FETCHING_USERS_PANEL = 'SET_ERROR_FETCHING_USERS_PANEL';
export const STOP_FETCHING_ADMIN_PANEL = 'STOP_FETCHING_ADMIN_PANEL';
export const STOP_FETCHING_USERS_PANEL = 'STOP_FETCHING_USERS_PANEL';
export const INCREMENT_GETTING_OFFSET = 'INCREMENT_GETTING_OFFSET';
export const UPDATE_ITEMS_ADMIN_PANEL = 'UPDATE_ITEMS_ADMIN_PANEL';

export const UPDATE_ITEMS_USERS_PANEL = 'UPDATE_ITEMS_USERS_PANEL';
export const INCREMENT_USERS_OFFSET = 'INCREMENT_USERS_OFFSET';
export const NONINCREMENT_USERS_OFFSET = 'NONINCREMENT_USERS_OFFSET';
export const RESET_USERS_OFFSET = 'RESET_USERS_OFFSET';
export const CHANGE_USERS_PAGE = 'CHANGE_USERS_PAGE';

export const SET_IS_FORBIDDEN = 'SET_IS_FORBIDDEN';

export const UPDATE_GET_USER_DATA = 'UPDATE_GET_USER_DATA';

export const startFetchingAdminPanel = () => ({
    type: START_FETCHING_ADMIN_PANEL,
})

export const stopFetchingAdminPanel = () => ({
    type: STOP_FETCHING_ADMIN_PANEL,
})

export const stopFetchingUsersPanel = () => ({
    type: STOP_FETCHING_USERS_PANEL,
})

export const incrementGettingOffset = () => ({
    type: INCREMENT_GETTING_OFFSET,
})

export const incrementUsersOffset = () => ({
    type: INCREMENT_USERS_OFFSET,
})
export const nonIncrementUsersOffset = () => ({
    type: NONINCREMENT_USERS_OFFSET,
})

export const resetUsersOffset = () => ({
    type: RESET_USERS_OFFSET,
})

export const updateItemsAdminPanel = (rawResponseData, state) => ({
    type: UPDATE_ITEMS_ADMIN_PANEL,
    payload: {
        items: processAdminPanelItems(rawResponseData, state),
        filterParams: rawResponseData.filterParams,
        count: rawResponseData.count,
        draft: rawResponseData.draft,
        review: rawResponseData.review,
        published: rawResponseData.published,
        rejected: rawResponseData.rejected,
    },
})

export const updateItemsUsersPanel = (rawResponseData, state) => ({
    type: UPDATE_ITEMS_USERS_PANEL,
    payload: {
        count: rawResponseData.count,
        users: processAdminPanelUsers(rawResponseData, state),
    },
})

// get user data
export const updateGetUserData = (rawResponseData, state) => ({
    type: UPDATE_GET_USER_DATA,
    payload: {
        user: processGetUserData(rawResponseData, state),
        owner_id: rawResponseData.spa_id,
    },
})

export const showChangeUserDataDialogSuccess = () => {
    return (dispatch) => {
        dispatch(openDialog(<DialogSupportComplete />))
    }
}

export const setErrorFetchingAdmin = (errorData) => ({
    type: SET_ERROR_FETCHING_ADMIN_PANEL,
    payload: {
        errorData,
    },
})

export const setErrorFetchingUsers = (errorData) => ({
    type: SET_ERROR_FETCHING_USERS_PANEL,
    payload: {
        errorData,
    },
})

export const setIsForbidden = () => ({
    type: SET_IS_FORBIDDEN,
})

export const changeAdminResultItemsOrdering = (type) => ({
    type: CHANGE_ADMIN_RESULT_ITEMS_ORDERING,
    payload: {
        type,
    },
})

export const changeUsersPage = (page) => ({
    type: CHANGE_USERS_PAGE,
    payload: {
        page,
    },
})

const prepareQueryParamsForGetting = (filterParams, state) => {
    const { type } = filterParams
    let query
    
    query = {
        limit: SEARCH_RESULT_ITEMS_PER_PAGE,
        offset: state.adminPanel.filtered.offset,
        
        query: type, // state.adminPanel.query,
    }
    
    return query
}

export const fetchItemsAdminPanel = (filterParams) => {
    return (dispatch, getState) => {
        const state = getState()
        const url = `https://tankimods.net`+urls.adminPanel //`https://tankimods.net/api/users/adminpanel/` //urls.modsOwner

        dispatch(startFetchingAdminPanel())

        const query = prepareQueryParamsForGetting(filterParams, state)
        
        const fetchPromise = fetch(url, { query }).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(batchActions([
                        setErrorFetchingAdmin(rawResponseData.context),
                        stopFetchingAdminPanel(),
                    ], SET_ERROR_FETCHING_ADMIN_PANEL))
                } else {
                    dispatch(batchActions([
                        updateItemsAdminPanel(rawResponseData.body, state),
                        stopFetchingAdminPanel(),
                    ], UPDATE_ITEMS_ADMIN_PANEL))
                }
            }, (errorData) => {
                dispatch(batchActions([
                    setErrorFetchingAdmin(errorData),
                    stopFetchingAdminPanel(),
                ], SET_ERROR_FETCHING_ADMIN_PANEL))
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

const prepareQueryParamsForFindingUsers = (username, state) => {
    let query
    
    query = {
        limit: USERS_RESULT_ITEMS_PER_PAGE,
        offset: (state.adminPanel.data.page - 1) * USERS_RESULT_ITEMS_PER_PAGE, //state.adminPanel.data.offset,
        username: username,
        //page: state.adminPanel.data.page,
    }
    
    return query
}

const prepareQueryParamsForGettingUsers = (data, state, firstFetch = true) => {
    let query
    
    query = {
        count: data.count,
        //isError: data.isError,
        //isFetching: data.isFetching,
        //isFetchedAll: data.isFetchedAll,
        limit: USERS_RESULT_ITEMS_PER_PAGE,
        offset: state.adminPanel.data.offset,
        page: state.adminPanel.data.page,

        users: data.users.slice(state.adminPanel.data.offset, USERS_RESULT_ITEMS_PER_PAGE+state.adminPanel.data.offset),
        //users: firstFetch ? data.users.slice(0, USERS_RESULT_ITEMS_PER_PAGE) : data.users.slice(state.adminPanel.data.offset, USERS_RESULT_ITEMS_PER_PAGE+state.adminPanel.data.offset),
    }
    
    return query
}

export const fetchItemsUsersPanel = (username, withSpinner = true) => {
    return (dispatch, getState) => {
        const state = getState()
        if (state.adminPanel.data.isFetchedAll) {
            return
        }

        const url = `https://tankimods.net`+urls.adminPanel //`https://tankimods.net/api/users/adminpanel/` //urls.modsOwner

        dispatch(startFetchingAdminPanel())

        const query = prepareQueryParamsForFindingUsers(username, state)
        
        const fetchPromise = fetch(url, { method: 'PUT', query }).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(batchActions([
                        setErrorFetchingUsers(rawResponseData),
                        stopFetchingUsersPanel(),
                    ], SET_ERROR_FETCHING_USERS_PANEL))
                //} else if (rawResponseData.status === 'ok' && rawResponseData.context.code === 204) {
                } else {
                    let responseData = prepareQueryParamsForGettingUsers(rawResponseData.context, state)
                    dispatch(batchActions([
                        updateItemsUsersPanel(responseData, state),
                        stopFetchingUsersPanel(),
                    ], UPDATE_ITEMS_USERS_PANEL))
                }
            }, (errorData) => {
                dispatch(batchActions([
                    setErrorFetchingUsers(errorData),
                    stopFetchingUsersPanel(),
                ], SET_ERROR_FETCHING_USERS_PANEL))
            })
        return withSpinner ? fetchWithSpinner(dispatch, fetchPromise) : fetchPromise
    }
}


// user data
export const fetchUserData = (spaid) => {
    return (dispatch, getState) => {
        const state = getState()

        let body = {
            owner_id: spaid,
            lang: state.currentAccount.lang,
        }

        const url = `https://tankimods.net`+urls.userDetails.replace(/:(spaid)/g, spaid) //`https://tankimods.net/api/users/` //urls.modsOwner
        
        const fetchPromise = fetch(url, { method: 'POST', body }).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    let error = get(rawResponseData, 'context.msg')
                    // if response not consist from context msg
                    if (!error) {
                        error = get(rawResponseData, 'context.body')
                    }
                    if (['user_not_found_in_bd__users', 'invalid_data__users'].includes(error)) {
                        dispatch(closeDialog())
                        dispatch(openDialogError(ERROR_USER_NOT_FOUND(error)))
                    } else {
                        dispatch(closeDialog())
                        dispatch(openDialogError('Код ошибки: '+error))
                    }
                } else {
                    dispatch(updateGetUserData(rawResponseData, state))
                }
            }, (errorData) => {
                dispatch(closeDialog())
                dispatch(openDialogError('Код ошибки: '+errorData))
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const updUserData = ({spaid, adminId, typeIds, roExpires}) => {
    return (dispatch, getState) => {
        const state = getState()

        let body = {
            user_type: typeIds,
            lang: state.currentAccount.lang,
            admin_id: adminId,
            user_id: spaid,
        }
        
        if (roExpires) {
            body = {
                ...body,
                ro_expires: roExpires,
            }
        }
        
        const url = `https://tankimods.net`+urls.userDetails.replace(/:(spaid)/g, spaid) // //urls.modsOwner

        const fetchPromise = fetch(url, { method: 'PUT', body }).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    let error = get(rawResponseData, 'context.msg')
                    // if response not consist from context msg
                    if (!error) {
                        error = get(rawResponseData, 'context.body')
                    }
                    if (['user_not_found_in_bd__users', 'invalid_data__users'].includes(error)) {
                        dispatch(openDialogError(ERROR_USER_NOT_FOUND(error)))
                    } else {
                        dispatch(openDialogError('Код ошибки: '+error))
                    }
                } else {
                    dispatch(openDialog('Данные пользователя обновлены!'))
                }
            }, (errorData) => {
                dispatch(openDialogError('Код ошибки: '+errorData))
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}


/* tickets for support panel */
export const START_FETCHING_SUPPORT_PANEL = 'START_FETCHING_SUPPORT_PANEL'
export const STOP_FETCHING_SUPPORT_PANEL = 'STOP_FETCHING_SUPPORT_PANEL'
export const START_FETCHING_MESSAGES_SUPPORT_PANEL = 'START_FETCHING_MESSAGES_SUPPORT_PANEL'
export const STOP_FETCHING_MESSAGES_SUPPORT_PANEL = 'STOP_FETCHING_MESSAGES_SUPPORT_PANEL'
export const UPDATE_SUPPORT_PANEL = 'UPDATE_SUPPORT_PANEL'
export const UPDATE_MESSAGES_SUPPORT_PANEL = 'UPDATE_MESSAGES_SUPPORT_PANEL'
export const UPDATE_MESSAGES_REPORT_PANEL = 'UPDATE_MESSAGES_REPORT_PANEL'
export const UPDATE_TICKETS = 'UPDATE_TICKETS'
export const UPDATE_TICKET = 'UPDATE_TICKET'
export const CHANGE_SUPPORT_PAGE = 'CHANGE_SUPPORT_PAGE'
export const SET_ERROR_SUPPORT_PANEL = 'SET_ERROR_SUPPORT_PANEL'
export const SET_ERROR_MESSAGES_SUPPORT_PANEL = 'SET_ERROR_MESSAGES_SUPPORT_PANEL'
export const SET_ERROR_LOAD_TICKET_INFO = 'SET_ERROR_LOAD_TICKET_INFO'

export const startFetchingSupportPanel = () => ({
    type: START_FETCHING_SUPPORT_PANEL,
})

export const stopFetchingSupportPanel = () => ({
    type: STOP_FETCHING_SUPPORT_PANEL,
})

export const setErrorSupportPanel = (errorData) => ({
    type: SET_ERROR_SUPPORT_PANEL,
    payload: {
        errorData,
    },
})

export const updateSupportPanel = (rawResponseData, state) => ({
    type: UPDATE_SUPPORT_PANEL,
    payload: {
        filterParams: rawResponseData.filter_params,
        reviewed: rawResponseData.reviewed,
        answered: rawResponseData.answered,
        offset: rawResponseData.offset,
        count: rawResponseData.count,

        items: processSupportPanel(rawResponseData, state),
    },
})

export const updateReportPanel = (rawResponseData, state) => ({
    type: UPDATE_SUPPORT_PANEL,
    payload: {
        filterParams: rawResponseData.filter_params,
        reviewed: rawResponseData.reviewed,
        answered: rawResponseData.answered,
        offset: rawResponseData.offset,
        count: rawResponseData.count,

        items: processReportPanel(rawResponseData, state),
    },
})

export const changeSupportPage = (page) => ({
    type: CHANGE_SUPPORT_PAGE,
    payload: {
        page,
    },
})

export const updateTicketInfo = (rawResponseData, state) => ({
    type: UPDATE_TICKET,
    payload: {
        ticket: processTicketInfo(rawResponseData, state),
    },
})

export const startFetchingMessagesSupportPanel = () => ({
    type: START_FETCHING_MESSAGES_SUPPORT_PANEL,
})

export const stopFetchingMessagesSupportPanel = () => ({
    type: STOP_FETCHING_MESSAGES_SUPPORT_PANEL,
})

export const updateMessagesSupportPanel = (rawResponseData, state) => ({
    type: UPDATE_MESSAGES_SUPPORT_PANEL,
    payload: {
        filterParams: rawResponseData.filter_params,
        modData: null,
        ticketId: rawResponseData.ticket_id,
        ownerId: rawResponseData.owner_id,
        ownerName: rawResponseData.owner_name,
        isClose: rawResponseData.is_close,
        createdAt: rawResponseData.created_at,
        problemTypes: rawResponseData.problem_types,
        count: rawResponseData.count,

        msg: processMessagesSupportPanel(rawResponseData, state),
    },
})

export const updateMessagesReportPanel = (rawResponseData, state) => ({
    type: UPDATE_MESSAGES_REPORT_PANEL,
    payload: {
        filterParams: rawResponseData.filter_params,
        modData: rawResponseData.mod_data,
        ticketId: rawResponseData.ticket_id,
        ownerId: rawResponseData.owner_id,
        ownerName: rawResponseData.owner_name,
        isClose: rawResponseData.is_close,
        createdAt: rawResponseData.created_at,
        problemTypes: rawResponseData.problem_types,
        count: rawResponseData.count,

        msg: processMessagesSupportPanel(rawResponseData, state),
    },
})

export const setErrorMessagesSupportPanel = (errorData) => ({
    type: SET_ERROR_MESSAGES_SUPPORT_PANEL,
    payload: {
        errorData,
    },
})

export const setErrorLoadTicketInfo = (errorData) => ({
    type: SET_ERROR_LOAD_TICKET_INFO,
    payload: {
        errorData,
    },
})

const prepareQueryParamsForGettingSupport = (filterParams, state) => {
    const { type } = filterParams
    let query
    
    query = {
        limit: SUPPORT_ITEMS_LIMIT,
        offset: (state.adminPanel.tickets.page - 1) * SUPPORT_ITEMS_LIMIT, //state.adminPanel.tickets.offset,
        
        query: type,
    }
    
    return query
}

export const fetchItemsSupportPanel = (filterParams) => {
    return (dispatch, getState) => {
        const state = getState()
        /*if ((filterParams['type'] === state.adminPanel.tickets.filterParams.type) && state.adminPanel.tickets.isFetchedAll) {
            return
        }*/
        
        const query = prepareQueryParamsForGettingSupport(filterParams, state)

        let url = `https://tankimods.net`+urls.support //`https://tankimods.net/api/support-groups/support/` //urls.modsOwner

        if (filterParams['type'] === 0) {
            url = `https://tankimods.net`+urls.reports
        }

        dispatch(startFetchingSupportPanel())
        
        const fetchPromise = fetch(url, { method: 'GET', query }).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(batchActions([
                        setErrorSupportPanel(rawResponseData.context.msg), 
                        stopFetchingSupportPanel()
                    ], SET_ERROR_SUPPORT_PANEL))
                } else {
                    if (rawResponseData.data.reports) {
                        dispatch(batchActions([
                            updateReportPanel(rawResponseData.data, state),
                            stopFetchingSupportPanel()
                        ], UPDATE_SUPPORT_PANEL))
                    } else {
                        dispatch(batchActions([
                            updateSupportPanel(rawResponseData.data, state),
                            stopFetchingSupportPanel()
                        ], UPDATE_SUPPORT_PANEL))
                    }
                }
            }, (errorData) => {
                dispatch(batchActions([
                    setErrorSupportPanel(errorData), 
                    stopFetchingSupportPanel()
                ], SET_ERROR_SUPPORT_PANEL))
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const fetchMessagesSupportPanel = (ticketId, type) => {
    return (dispatch, getState) => {
        const state = getState()
        if (state.adminPanel.ticketView.isFetchedAll) {
            return
        }

        const url = `https://tankimods.net`+urls.support+`?ticket_id=${ticketId}&type=${type}&role=agent` //`https://tankimods.net/api/support-groups/support/` //urls.modsOwner

        dispatch(startFetchingMessagesSupportPanel())
        
        const fetchPromise = fetch(url, { method: 'GET' }).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(batchActions([
                        setErrorMessagesSupportPanel(rawResponseData.context.msg), 
                        stopFetchingMessagesSupportPanel()
                    ], SET_ERROR_MESSAGES_SUPPORT_PANEL))
                } else {
                    if (rawResponseData.data.filter_params.type === 0) {
                        dispatch(batchActions([
                            updateMessagesReportPanel(rawResponseData.data, state),
                            stopFetchingMessagesSupportPanel()
                        ], UPDATE_MESSAGES_REPORT_PANEL))
                    } else {
                        dispatch(batchActions([
                            updateMessagesSupportPanel(rawResponseData.data, state),
                            stopFetchingMessagesSupportPanel()
                        ], UPDATE_MESSAGES_SUPPORT_PANEL))
                    }
                }
            }, (errorData) => {
                dispatch(batchActions([
                    setErrorMessagesSupportPanel(errorData), 
                    stopFetchingMessagesSupportPanel()
                ], SET_ERROR_MESSAGES_SUPPORT_PANEL))
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

// support answer ticket from agent
export const supportAnswer = ({message, fileId, fileToken, ticketId, agentId}) => {
    return (dispatch, getState) => {
        const state = getState()

        let body = {
            message: message,
            lang: state.currentAccount.lang,
            ticket_id: ticketId,
            agent_id: agentId,
        }
        
        if (fileId && fileToken) {
            body = {
                ...body,
                temporary_file: fileId,
                temporary_file_access_token: fileToken,
            }
        }

        const url = `https://tankimods.net`+urls.support+`?ticket_id=`+ticketId+`&answer=agent` //  /api/support-groups/support/    urls.support
        
        const fetchPromise = fetch(url, { method: 'POST', body }).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(batchActions([
                        setErrorMessagesSupportPanel(rawResponseData.context.msg), 
                        stopFetchingMessagesSupportPanel()
                    ], SET_ERROR_MESSAGES_SUPPORT_PANEL))
                } else {
                    dispatch(batchActions([
                        updateMessagesSupportPanel(rawResponseData.data, state),
                        stopFetchingMessagesSupportPanel()
                    ], UPDATE_MESSAGES_SUPPORT_PANEL))
                    //dispatch(setSupportCompleted())
                }
            }, (errorData) => {
                dispatch(batchActions([
                    setErrorMessagesSupportPanel(errorData), 
                    stopFetchingMessagesSupportPanel()
                ], SET_ERROR_MESSAGES_SUPPORT_PANEL))
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

// fast answer for ticket
export const fastAnswer = (ticketId, content, agentId) => {
    return (dispatch, getState) => {
        const url = `https://tankimods.net`+urls.support+`?ticket_id=${ticketId}&content=${content}&agent_id=${agentId}` //`https://tankimods.net/api/support-groups/support/` //urls.modsOwner
        
        dispatch(startFetchingMessagesSupportPanel())
        
        const fetchPromise = fetch(url, { method: 'PUT' }).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(batchActions([
                        setErrorSupportPanel(rawResponseData.context.msg), 
                        stopFetchingSupportPanel(),
                        openDialogError(<React.Fragment>К сожалению Ваше сообщение не отправлено<br /><br />Error: {rawResponseData.context.msg}</React.Fragment>, 'Произошла ошибка')
                    ], SET_ERROR_SUPPORT_PANEL))
                } else {
                    dispatch(openDialog('Сообщение отправлено!'))
                }
            }, (errorData) => {
                dispatch(batchActions([
                    setErrorSupportPanel(errorData), 
                    stopFetchingSupportPanel(),
                    openDialogError(<React.Fragment>К сожалению Ваше сообщение не отправлено<br /><br />Error: {errorData}</React.Fragment>, 'Произошла ошибка')
                ], SET_ERROR_SUPPORT_PANEL))
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

// show OR hide for ticket
export const showHideTicket = (ticketId, isClosed) => {
    return (dispatch, getState) => {
        const url = `https://tankimods.net`+urls.support+`?is_hide=true&ticket_id=${ticketId}&is_close=${isClosed}` //`https://tankimods.net/api/support-groups/support/` //urls.modsOwner
        
        dispatch(startFetchingMessagesSupportPanel())
        
        const fetchPromise = fetch(url, { method: 'PUT' }).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(batchActions([
                        setErrorSupportPanel(rawResponseData.context.msg), 
                        stopFetchingSupportPanel(),
                        openDialogError(<React.Fragment>Невозможно выполнить действие<br /><br />Error: {rawResponseData.context.msg}</React.Fragment>, 'Произошла ошибка')
                    ], SET_ERROR_SUPPORT_PANEL))
                } else {
                    window.location.reload();
                    //dispatch(openDialog('Сообщение отправлено!'))
                }
            }, (errorData) => {
                dispatch(batchActions([
                    setErrorSupportPanel(errorData), 
                    stopFetchingSupportPanel(),
                    openDialogError(<React.Fragment>Невозможно выполнить действие<br /><br />Error: {errorData}</React.Fragment>, 'Произошла ошибка')
                ], SET_ERROR_SUPPORT_PANEL))
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

// delete message from support ticket
export const deleteAnswer = (id, ticketId) => {
    return (dispatch, getState) => {
        const state = getState()

        const url = `https://tankimods.net`+urls.support+`?ticket_id=${ticketId}&message_id=${id}` //`https://tankimods.net/api/support-groups/support/` //urls.modsOwner
        dispatch(startFetchingMessagesSupportPanel())
        
        const fetchPromise = fetch(url, { method: 'DELETE' }).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(batchActions([
                        setErrorMessagesSupportPanel(rawResponseData.context.msg), 
                        stopFetchingMessagesSupportPanel()
                    ], SET_ERROR_MESSAGES_SUPPORT_PANEL))
                } else {
                    dispatch(batchActions([
                        updateMessagesSupportPanel(rawResponseData.data, state),
                        stopFetchingMessagesSupportPanel()
                    ], UPDATE_MESSAGES_SUPPORT_PANEL))
                }
            }, (errorData) => {
                dispatch(batchActions([
                    setErrorMessagesSupportPanel(errorData), 
                    stopFetchingMessagesSupportPanel()
                ], SET_ERROR_MESSAGES_SUPPORT_PANEL))
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

// delete ticket and all messages
export const deleteTicket = (ticketId) => {
    return (dispatch, getState) => {
        //const state = getState()

        const url = `https://tankimods.net`+urls.support+`?delete_ticket=true&ticket_id=${ticketId}` //`https://tankimods.net/api/support-groups/support/` //urls.modsOwner
        dispatch(startFetchingMessagesSupportPanel())
        
        const fetchPromise = fetch(url, { method: 'DELETE' }).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(batchActions([
                        setErrorSupportPanel(rawResponseData.context.msg), 
                        stopFetchingSupportPanel()
                    ], SET_ERROR_SUPPORT_PANEL))
                } else {
                    window.location.href = '/admin-panel/support/'
                    //dispatch(fetchItemsSupportPanel())
                }
            }, (errorData) => {
                dispatch(batchActions([
                    setErrorSupportPanel(errorData), 
                    stopFetchingSupportPanel()
                ], SET_ERROR_SUPPORT_PANEL))
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const loadTicketInfo = (ticketId) => {
    return (dispatch, getState) => {
        //const state = getState()

        let body = {
            ticket_id: ticketId,
            //sms_id: smsId,
        }
        
        const url = `https://tankimods.net`+urls.loadTicketInfo //.replace(/:(spaid)/g, spaid) // //urls.modsOwner

        const fetchPromise = fetch(url, { method: 'POST', body }).promise
            .then((rawResponseData) => {
                debugger
                if (rawResponseData.status === 'error') {
                    dispatch(setErrorLoadTicketInfo(rawResponseData.context.msg))
                } else {
                    dispatch(updateTicketInfo(rawResponseData.data))
                }
            }, (errorData) => {
                dispatch(setErrorLoadTicketInfo(errorData))
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}